/**
 * METRIC-DEFINITIONS W3-T12 (parity walk FIX-07): "Year to Date" on the PO Line
 * Dashboard is the tenant's FISCAL year start → today (the Group KPI's FYTD
 * basis). The label names the start date so two tabs never carry two meanings
 * of one word: "FYTD, 1 Apr → today"; a calendar-year tenant reads "YTD, 1 Jan → today".
 */
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function fytdLabel(windowStart?: string | null): string {
  if (!windowStart) return 'fiscal year → today';
  const [y, m, d] = windowStart.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return 'fiscal year → today';
  const prefix = m === 1 && d === 1 ? 'YTD' : 'FYTD';
  return `${prefix}, ${d} ${MONTHS[m - 1]} → today`;
}
